import { styled } from '@mui/material/styles';
import { Card } from '@components/CardItem/styles';

export {
    CardFooter as Footer,
    CardControls as Controls,
    CardIconButton as StyledIconButton,
} from '@components/CardItem/styles';

export const Container = styled(Card)({
    '@media (max-width: 700px)': {
        maxWidth: 'none',
    },
});

export const Header = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
});

export const TitleWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
});

export const ChannelIconWrapper = styled('span')({
    display: 'inline-flex',
    alignItems: 'center',
    flex: '0 0 auto',
    '& svg': {
        width: 18,
        height: 18,
    },
});

export const TeamWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    minHeight: 32,
});
